module.exports = __webpack_public_path__ + "img/num_15.a3225025.png";